import { outputUnits, outputUnitLabels, defaultOutputUnitBySubtype } from "../../helpers/dataHelpers/activityCategories";

// Renders <option> elements for a <datalist>.
// Shows the suggested unit (from activitySubtype) first, then all others.
const DatalistOutputUnits = ({ activitySubtype }) => {
  const suggested = activitySubtype ? defaultOutputUnitBySubtype[activitySubtype] : null;

  const sorted = suggested
    ? [suggested, ...outputUnits.filter(u => u !== suggested)]
    : outputUnits;

  return (
    <>
      {sorted.map(unit => (
        <option key={unit} value={outputUnitLabels[unit] || unit} />
      ))}
    </>
  );
};

export default DatalistOutputUnits;
